import React from 'react';
import PropTypes from 'prop-types';
import { General } from '../../../shared';

const PhotoDownload = ({ className, href, filename, onDownload, onDownloadComplete, loading }) => {
	const handleClick = async (e) => {
		e.preventDefault();
		if (onDownload) onDownload();

		try {
			const response = await fetch(href);
			const blob = await response.blob();
			const url = URL.createObjectURL(blob);

			General.downloadURI(url, filename);

			URL.revokeObjectURL(url);

			if (onDownloadComplete) onDownloadComplete();
		} catch (err) {						
			console.log("error downloading photo", err);
			if (onDownloadComplete) onDownloadComplete();
		}
	};

	return (
		<a
			className={`PhotoDownload ${className} ${loading ? 'PhotoDownload--loading' : ''}`}
			href={href}
			onClick={loading ? (e) => e.preventDefault() : handleClick}
			download={filename}
			style={{ pointerEvents: loading ? 'none' : 'auto', opacity: loading ? 0.6 : 1 }}
			aria-disabled={loading}
			tabIndex={loading ? -1 : 0}
		>
			{loading ? (
				<span className="PhotoDownload__spinner" />
			) : (
				<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24">
					<circle fill="#ffffff" cx="12" cy="13" r="5" />
					<path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z" fill="#f57c00" />
				</svg>
			)}
		</a>
	);
};

PhotoDownload.propTypes = {
	className: PropTypes.string,
	href: PropTypes.string,
	filename: PropTypes.string,
	onDownload: PropTypes.func,
	onDownloadComplete: PropTypes.func,
	loading: PropTypes.bool,
};

PhotoDownload.defaultProps = {
	className: '',
	href: '',
	filename: '',
	onDownload: () => {},
	onDownloadComplete: () => {},
	loading: false,
};

export default PhotoDownload;
